import React, { useCallback, useMemo } from 'react';

// Styles & Assets
import styles from './SideNavbarWrapper.module.css';

// Context
import GeneralContext from '../../context/GeneralContext';
import { GlobalModalContextProvider } from '../../context/GlobalModelContext';

// Hooks
import { useContext, useEffect, useState } from 'react';
import usePatientsData from '../../hooks/usePatientsData';
import useUIPersistance from '../../hooks/useUIPersistance';
import { useIdle } from '../../hooks/useIdle';
import { useTranslation } from 'react-i18next';
import useInitialRequest from '../../hooks/useInitialRequest';

// Components
import Sidebar from '../../components/Sidebar/Sidebar/Sidebar';
import Modal from '../../components/UI/Modal/Modal';
import ErrorSpinnerWrapper from '../../components/UI/ErrorSpinnerWrapper.tsx/ErrorSpinnerWrapper';

// Other
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { canAccessBCHome, canAccessUbikare } from '../../services/user';
// import SelectEnvironmentDialog from './SelectEnvironmentDialog/SelectEnvironmentDialog';

// SideNavbarWrapper: Wrapper of the Sidebar. It also calls the useInitialRequestHooks
// and logs out when the token expires.
const SideNavbarWrapper: React.FC = () => {

    const navigate = useNavigate();

    const location = useLocation();
    const accessToken = useMemo(() => {
        const token = location?.state?.token;
        if (!token || typeof token !== 'string') return null;
        return token as string;
    }, [location?.state?.token])

    const { t } = useTranslation();

    const generalContext = useContext(GeneralContext);
    const [width, setWidth] = useState(window.innerWidth);

    const { getUIPersistence } = useUIPersistance();
    const { loading, error } = usePatientsData();
    const { loading: loadingInitReq, error: errorInitReq, startRequests } = useInitialRequest(accessToken);

    const accessAllowedPlatform = useCallback(() => {
        if (!canAccessBCHome() && canAccessUbikare()) {
            window.location.href = 'https://bettercare.spa.ubikare.io/';
            return;
        }
    }, [])

    useEffect(() => {
        accessAllowedPlatform();
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [accessAllowedPlatform]);

    useEffect(() => {
        getUIPersistence();
        startRequests();
    }, [getUIPersistence, startRequests]);

    const idle = useIdle();

    useEffect(() => {
        if (!idle) return;
        navigate('/logout');
        setTimeout(() => {
            alert(t('session_expired_message'))
        }, 500)
    }, [idle, navigate, t])


    return (
        <main className={styles.rootLayoutContainer}>
            {/* <Modal show={showModalEnviroment} setShowModal={setShowModalEnviroment}>
                <SelectEnvironmentDialog showDialog={setShowModalEnviroment} />
            </Modal>  */}
            {width < 1200 ?
                <Modal
                    show={generalContext.openSidebar}
                    setShowModal={generalContext.setOpenSidebar}
                    classesModal={styles.sideBarModal}
                    classesBackdrop={styles.sideBarBackdrop}
                >
                    <Sidebar modalSidebar />
                </Modal>
                : generalContext.openSidebar ?
                    <div className={styles.sidebarWrapper}>
                        <Sidebar />
                    </div>
                    : null
            }
            <div className={styles.spinnerContainer}>
                <ErrorSpinnerWrapper
                    error={error || errorInitReq}
                    loading={loadingInitReq || loading}
                >
                    <GlobalModalContextProvider>
                        <Outlet />
                    </GlobalModalContextProvider>
                </ErrorSpinnerWrapper>
            </div>
        </main>
    );
};

export default SideNavbarWrapper;